export default __webpack_public_path__ + "static/media/train2.48daade8.png";